import axios from 'axios';

// Get base URL from environment variable or fallback to hardcoded value
const baseURL = process.env.REACT_APP_API_URL;

// Create Axios instance
const api = axios.create({
  baseURL: 'https://api-v1.htcl.co.in/',
  timeout: 15000, // Increased timeout for real API calls (15 seconds)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const sessionToken = localStorage.getItem('session_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (sessionToken) {
      config.headers['Session-Token'] = sessionToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log API errors for debugging
    console.error('❌ API Error:', {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      url: error.config?.url,
      method: error.config?.method,
    });

    if (error.response?.status === 401) {
      // Token expired or unauthorized
      localStorage.removeItem('token');
      localStorage.removeItem('session_token');
      window.location.href = '/login';
    }

    if (error.response?.status === 409) {
      // Session conflict
      window.dispatchEvent(new Event('session-conflict'));
    }

    if (error.response?.status === 403) {
      // Permission denied
      window.dispatchEvent(
        new CustomEvent('permission-denied', {
          detail: error.response.data.permission,
        })
      );
    }

    return Promise.reject(error);
  }
);

export default api;